import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray, CreateIntegerRange, deepCopy } from "../../components/Common";
import { updateLayout2D, updateLayout3D } from "../../redux_store/appStateHelper";
import { THREED_MODE, THREED_MINI_MODE } from "../../redux_store/appState";

import * as BSL_Common from "../../components/BSL_CommonControls";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Typography from "@material-ui/core/Typography";
import ListSubheader from "@material-ui/core/ListSubheader";
import Slider from "@material-ui/core/Slider";
import MenuItem from "@material-ui/core/MenuItem";
import Link from "@material-ui/core/Link";

import { blue } from "@material-ui/core/colors";

import {
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
    updateAreaSpecificationBeamPost,
    deleteBeamPostMod,
} from "../../redux_store/jobState";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import BSL_Select from "../../components/BSL_Select";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";

const AttachmentSlider = withStyles({
    root: {
        color: "#3a8589",
        height: 3,
        padding: "13px 0",
        marginTop: "20px",
    },
    thumb: {
        height: "20px !important",
        width: "20px !important",
        backgroundColor: "#a90000",
        border: "2px solid #a90000",
        marginTop: "-8px !important",
        marginLeft: "-10px !important",
        borderRadius: "25%",
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 3px)",
        top: 15,
        "& *": {
            background: "transparent",
            color: "#000",
        },
    },
    track: {
        height: 0,
        // background: "repeating-linear-gradient(45deg,#B1B118,#B1B118 2px,#F0F2E6 2px,#F0F2E6 10px)"
    },
    rail: {
        color: "#FFF",
        opacity: 1,
        height: 16,
        marginTop: "-8px",
        border: "2px solid #7AB004",
    },
})(Slider);

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper id="draggable-dialog-title" {...props} />
        </Draggable>
    );
}

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    root: {
        width: 300,
    },
    handleText: {
        textAlign: "right",
        background: "#0000",
        width: "46px",
        border: "1px",
        marginLeft: "10px",
        // position: 'absolute',
        // top: '-25px',
    },
    attachLengthText: {
        textAlign: "center",
        width: "55px",
        border: "0px",
    },
    label: {
        width: "200%",
    },
    handleContainer: {
        display: "flex",
        top: "-25px",
        width: "60px",
        position: "absolute",
        marginLeft: "-10px",
    },
    ghostPostContainer: {
        display: "flex",
        position: "absolute",
    },
    ghostPost: {
        width: "20px !important",
        border: "1px dotted #a8a8a8",
        height: "20px !important",
        marginLeft: "-10px !important",
        borderRadius: "25%",
        backgroundColor: "#9b9b9b17",
    },
    ghostPostText: {
        top: "-17px",
        marginLeft: "-17px",
        position: "absolute",
        fontSize: "11px",
    },
    ghostSplice: {
        width: "1px",
        border: "1px dotted #7ab004",
        height: "20px",
        marginLeft: "-1px",
        background: "#7ab004",
        position: "absolute",
    },
    handleEndAdornment: {
        fontSize: "0.7rem",
    },
    handleBar: {
        position: "absolute",
        left: "32px",
        top: "37px",
        color: "#f9a4a4",
        fontSize: "125%",
        fontWeight: "100",
    },
    handleBarTop: {
        top: "10px",
        color: "#a90000",
    },
    disabled: {
        color: "grey",
    },
    end: {
        width: "4px !important",
        border: "none !important",
        marginLeft: "0px !important",
    },
});

function distanceVector(ref) {
    //format (xx/yy/zz);(xx/yy/zz)
    let split = ref.split(";");
    let p1 = split[0].replace("(", "").replace(")", "");
    let p1_split = p1.split("/");
    let p2 = split[1].replace("(", "").replace(")", "");
    let p2_split = p2.split("/");
    var dx = Number(p1_split[0]) - Number(p2_split[0]);
    var dy = Number(p1_split[1]) - Number(p2_split[1]);
    var dz = Number(p1_split[2]) - Number(p2_split[2]);

    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

function distanceVector2D(ref) {
    //format (xx/yy/zz);(xx/yy/zz)
    let split = ref.split(";");
    let p1 = split[0].replace("(", "").replace(")", "");
    let p1_split = p1.split("/");
    let p2 = split[1].replace("(", "").replace(")", "");
    let p2_split = p2.split("/");
    var dx = Number(p1_split[0]) - Number(p2_split[0]);
    var dy = Number(p1_split[1]) - Number(p2_split[1]);

    return Math.sqrt(dx * dx + dy * dy);
}

const END_TYPES = {
    POST: "POST",
    BK2: "BK2",
};

export default function SpecModifyBeamPostsDialog(props) {
    const classes = useStyles();
    const sliderRef = React.useRef(null);
    const dispatch = useDispatch();
    const { onClose, open, item } = props;
    const config = useSelector((state) => state.config);
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const ConfigDesignOptions = useSelector((state) => state.config.design_options);
    const beam_types = useSelector((state) => state.config.beam_types);
    const post_types = useSelector((state) => state.config.post_types);
    const SplicingLength = useSelector((state) => state.job?.DesignParameters?.SplicingLength);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const areaIndex = item?.areaIndex ? item?.areaIndex : 0;
    const area_BEAMS_AND_POSTS = AreaSpecifications?.[item?.areaIndex ? item?.areaIndex : 0]?.BEAMS_AND_POSTS;
    const MaxPostSpacing = area_BEAMS_AND_POSTS?.PostSpacing ? Number(area_BEAMS_AND_POSTS.PostSpacing) : 20000;
    const areaDataBeamMods = AreaSpecifications[0].BEAMMODIFICATIONS;
    const designType = AreaSpecifications[item.areaIndex].SHAPE.DesignType;

    const THREED_mode = app.designer[THREED_MODE];
    const threed_mini_mode = app.designer[THREED_MINI_MODE];

    const design_options = ConfigDesignOptions[designType];

    const filtered_areaDataBeamMods = areaDataBeamMods.filter((mod) => {
        return mod.Area === undefined || mod.Area === item.areaIndex;
    });

    const ref = item ? item.ref : null;
    const ref2 = item ? item.ref2 : null;
    const ref4 = item ? item.ref4 : null;
    const data_mods = getItemFromArray(
        filtered_areaDataBeamMods,
        ref2 ? "Ref2" : "Ref",
        ref2 ? ref2 : ref4,
        "Ref4",
        ref4,
        30,
        90,
        true
    );

    const [startPostSetting, setStartPostSetting] = React.useState(
        data_mods?.SetPost1 !== undefined ? data_mods.SetPost1 : -1
    );
    const [endPostSetting, setEndPostSetting] = React.useState(
        data_mods?.SetPost2 !== undefined ? data_mods.SetPost2 : -1
    );
    const [initialised, setInitialised] = React.useState(false);

    let END_1 = END_TYPES.POST;
    if (item.E1 === "CON") END_1 = END_TYPES.BK2;
    if (item.E1 === "F") END_1 = END_TYPES.BK2;
    if (item.E1 === "W") END_1 = END_TYPES.BK2;
    if (item.E1 === "End Cap") END_1 = END_TYPES.BK2;

    if (item?.EP1) {
        if (["B", "F", "W", "CON", "End Cap"].includes(item?.EP1)) END_1 = END_TYPES.BK2;
        else if (item?.EP1 === "C") END_1 = END_TYPES.POST;
    }
    if (item?.OH1 && toNumber(item?.OH1) > 55) END_1 = END_TYPES.POST;
    if (startPostSetting === 0) END_1 = END_TYPES.BK2;
    if (startPostSetting === 1) END_1 = END_TYPES.POST;
    // console.log("startPostSetting", startPostSetting, END_1);
    let END_2 = END_TYPES.POST;
    if (item.E2 === "CON") END_2 = END_TYPES.BK2;
    if (item.E2 === "F") END_2 = END_TYPES.BK2;
    if (item.E2 === "W") END_2 = END_TYPES.BK2;
    if (item.E2 === "End Cap") END_2 = END_TYPES.BK2;
    if (item?.EP2) {
        if (["B", "F", "W", "CON", "End Cap"].includes(item?.EP2)) END_2 = END_TYPES.BK2;
        else if (item?.EP2 === "C") END_2 = END_TYPES.POST;
    }
    if (item?.OH2 && toNumber(item?.OH2) > 55) END_2 = END_TYPES.POST;
    if (endPostSetting === 0) END_2 = END_TYPES.BK2;
    if (endPostSetting === 1) END_2 = END_TYPES.POST;

    const beam_length_actual = item && item.lengthQQ ? item.lengthQQ : Math.round(distanceVector(ref4));
    let beam_length = Math.round(distanceVector(ref4));
    const beam_length_xy = Math.round(distanceVector2D(ref4));
    const beam_length_xy_Ref_actual = Math.round(distanceVector(ref));
    const beam_length_xy_Ref = Math.round(distanceVector2D(ref));

    let min_int_cols = 0;
    // min_int_cols = Math.trunc((beam_length - 1) / 8000);

    let beamType = item.typeQQ ? item.typeQQ : "";
    if (item.typeQQ && item.typeQQ == "beam") {
        if (item.nameQQ.startsWith("FB")) beamType = "beam1";
        if (item.nameQQ.startsWith("CB")) beamType = "beam1";
        if (item.nameQQ.startsWith("P") || (item.ref2 && item.ref2.includes("Purlin"))) beamType = "beam2";
        if (item.nameQQ.startsWith("R")) beamType = "beam3";
        if (item.nameQQ.startsWith("SF")) beamType = "beam3";
        else beamType = "beam1";
    }

    if (beamType !== "beam1") {
        if (startPostSetting === -1) END_1 = END_TYPES.BK2;
        if (endPostSetting === -1) END_2 = END_TYPES.BK2;
        beam_length = beam_length_actual;
    }
    if (beam_length_xy - beam_length > 1000) {
        beam_length = beam_length_xy;
    }
    let max_overhang = Math.min(beam_length / 4, 1000);

    //defaults MODIFICATIONS

    let defaultPostType = area_BEAMS_AND_POSTS.PostType;
    let posttype = post_types[defaultPostType];

    let first_post_adj = posttype.depth / 2;
    // console.log("posttype", posttype);
    let last_post_adj = posttype.depth / 2;

    if (END_1 === END_TYPES.BK2) first_post_adj = 0;
    if (END_2 === END_TYPES.BK2) last_post_adj = 0;
    // console.log("first_post_adj", first_post_adj);
    // console.log("last_post_adj", last_post_adj);

    React.useEffect(() => {
        if (initialised) handleNumInternalPostsValue(null, numInternalPostsValue);
    }, [END_1, END_2]);

    let default_OH1_value =
        item && item?.OH1
            ? toNumber(item?.OH1)
            : data_mods && data_mods.Overhang1 && END_1 === END_TYPES.POST
            ? data_mods.Overhang1
            : 0;

    const [overhang1Value, setOverhang1Value] = React.useState(default_OH1_value);

    let default_OH2_value =
        item && item?.OH2
            ? toNumber(item?.OH2)
            : data_mods && data_mods.Overhang2 && END_2 === END_TYPES.POST
            ? data_mods.Overhang2
            : 0;
    const [overhang2Value, setOverhang2Value] = React.useState(default_OH2_value);

    const [evenlySpacePosts, setEvenlySpacePosts] = React.useState(data_mods ? data_mods.EvenlySpacePosts : true);
    const handleEvenlySpacePosts = (event, newValue, num_int_post = null) => {
        console.log("handleEvenlySpacePosts", event, newValue, num_int_post);

        let newevenlySpacePosts = newValue !== undefined && newValue != null ? newValue : event.target.value;
        if (newevenlySpacePosts?.props?.value !== undefined) newevenlySpacePosts = newevenlySpacePosts.props.value;

        if (newevenlySpacePosts) {
            // if (num_int_post === null) num_int_post = numInternalPostsValue;
            // console.log(beam_length, overhang1Value, overhang2Value, first_post_adj, last_post_adj);
            // console.log(
            //     "calc length",
            //     beam_length -
            //         Math.max(overhang1Value + first_post_adj, first_post_adj) -
            //         Math.max(overhang2Value + last_post_adj, last_post_adj)
            // );
            // // let spacing = (beam_length - Math.max(overhang1Value + first_post_adj, first_post_adj) - Math.max(overhang2Value + last_post_adj, last_post_adj)) / (num_int_post + 1);
            // // console.log("calc length",(beam_length-overhang1Value-overhang2Value-first_post_adj-last_post_adj));
            // let num_cols = num_int_post;
            // if (END_1 == END_TYPES.POST) num_cols++;
            // if (END_2 == END_TYPES.POST) num_cols++;
            // let spacing =
            //     (beam_length - posttype.depth * num_cols - overhang1Value - overhang2Value) / (num_int_post + 1);
            // console.log("spacingx", spacing);

            // // let new_internalPostOffsetsValues = [Math.max(overhang1Value + first_post_adj, first_post_adj)];
            // let new_internalPostOffsetsValues = [overhang1Value ? overhang1Value : first_post_adj];
            // if (num_int_post > 0)
            //     for (var i = 1; i < num_int_post + 1; i++) {
            //         // if (i === 1)  new_internalPostOffsetsValues.push(Math.trunc(overhang1Value+first_post_adj+(i * spacing)));
            //         // else if (i === numInternalPostsValue)  new_internalPostOffsetsValues.push(Math.trunc(overhang1Value+last_post_adj+(i * spacing)));
            //         // new_internalPostOffsetsValues.push(Math.round(Math.max(overhang1Value + first_post_adj, first_post_adj) + (i * spacing)));

            //         let space = 0;
            //         if (END_1 == END_TYPES.POST) space = overhang1Value + posttype.depth;
            //         space += spacing + (i - 1) * (spacing + posttype.depth) + posttype.depth / 2;
            //         new_internalPostOffsetsValues.push(Math.round(space));
            //     }
            // // new_internalPostOffsetsValues.push(beam_length - Math.max(overhang2Value + last_post_adj, last_post_adj));
            // new_internalPostOffsetsValues.push(beam_length - (overhang2Value ? overhang2Value : last_post_adj));
            // setInternalPostOffsetsValues(new_internalPostOffsetsValues);
            let oh_1_value = overhang1Value;
            if (END_1 === END_TYPES.BK2) {
                setOverhang1Value(0);
                oh_1_value = 0;
            } else if (END_1 === END_TYPES.POST && overhang1Value === 0) {
                setOverhang1Value(posttype.depth / 2);
                oh_1_value = posttype.depth / 2;
            }
            let oh_2_value = overhang2Value;
            if (END_2 === END_TYPES.BK2) {
                setOverhang2Value(0);
                oh_2_value = 0;
            } else if (END_2 === END_TYPES.POST && overhang2Value === 0) {
                setOverhang2Value(posttype.depth / 2);
                oh_2_value = posttype.depth / 2;
            }

            let new_internalPostOffsetsValues = getPostsLocations(
                numInternalPostsValue,
                oh_1_value,
                oh_2_value,
                newevenlySpacePosts
            );
            console.log("new_internalPostOffsetsValues", new_internalPostOffsetsValues);
            if (setInternalPostOffsetsValues) setInternalPostOffsetsValues(new_internalPostOffsetsValues);
        }

        setEvenlySpacePosts(newevenlySpacePosts);
    };

    var getPostsLocations = function (
        this_numInternalPostsValue,
        oh_1_value = null,
        oh_2_value = null,
        set_evenlySpacePosts = undefined
    ) {
        let new_internalPostOffsetsValues = internalPostOffsetsValues ? [...internalPostOffsetsValues] : [];

        let start_OH = oh_1_value !== null ? oh_1_value : overhang1Value;
        // if (overhang1Value === 0 && item?.OH1 && Number(item.OH1) > first_post_adj + 5)
        // if (overhang1Value === 0 && item?.OH1) start_OH = Number(item.OH1);
        let end_OH = oh_2_value !== null ? oh_2_value : overhang2Value;
        // if (overhang2Value === 0 && item?.OH2 && Number(item.OH2) > last_post_adj + 5)
        // if (overhang2Value === 0 && item?.OH2) end_OH = Number(item.OH2);

        if (set_evenlySpacePosts === undefined) set_evenlySpacePosts = evenlySpacePosts;

        if (set_evenlySpacePosts) {
            // console.log("beam_length", beam_length);
            // console.log("overhang1Value", overhang1Value, start_OH, first_post_adj);
            // console.log("overhang2Value", overhang2Value, end_OH, last_post_adj);

            // let spacing = (beam_length - Math.max(overhang1Value + first_post_adj, first_post_adj) - Math.max(overhang2Value + last_post_adj, last_post_adj)) / (this_numInternalPostsValue + 1);
            let num_cols = this_numInternalPostsValue;
            if (END_1 == END_TYPES.POST) num_cols++;
            if (END_2 == END_TYPES.POST) num_cols++;

            let length_to_split =
                beam_length - (start_OH - first_post_adj) - (end_OH - last_post_adj) - posttype.depth * num_cols;
            // if (END_1 == END_TYPES.BK2) length_to_split -= posttype.depth;
            // if (END_2 == END_TYPES.BK2) length_to_split -= posttype.depth;
            let spacing = length_to_split / (this_numInternalPostsValue + 1);

            console.log(
                "spacing",
                length_to_split,
                spacing,
                beam_length,
                posttype.depth,
                num_cols,
                end_OH - last_post_adj,
                start_OH - first_post_adj
            );
            // new_internalPostOffsetsValues = [Math.max(start_OH + first_post_adj, first_post_adj)];
            new_internalPostOffsetsValues = [start_OH != null ? start_OH : first_post_adj];
            if (this_numInternalPostsValue > 0)
                for (var i = 1; i < this_numInternalPostsValue + 1; i++) {
                    // if (i === 1)  new_internalPostOffsetsValues.push(Math.trunc(overhang1Value+first_post_adj+(i * spacing)));
                    // else if (i === numInternalPostsValue)  new_internalPostOffsetsValues.push(Math.trunc(overhang1Value+last_post_adj+(i * spacing)));
                    // else
                    let space = start_OH;
                    if (END_1 == END_TYPES.POST) space = start_OH + posttype.depth / 2;
                    // if (i == 1 && END_1 == END_TYPES.BK2) space += posttype.depth;
                    space += spacing + (i - 1) * (spacing + posttype.depth) + posttype.depth / 2;
                    console.log("adding post:", Math.round(space));
                    new_internalPostOffsetsValues.push(Math.round(space));
                }
            // new_internalPostOffsetsValues.push(beam_length - Math.max(end_OH + last_post_adj, last_post_adj));
            new_internalPostOffsetsValues.push(beam_length - (end_OH != null ? end_OH : last_post_adj));
            // setInternalPostOffsetsValues(new_internalPostOffsetsValues);
        } else {
            if (END_1 === END_TYPES.BK2) new_internalPostOffsetsValues[0] = 0;
            if (END_2 === END_TYPES.BK2)
                new_internalPostOffsetsValues[new_internalPostOffsetsValues.length - 1] = beam_length;

            var secondMax = function (arr) {
                var max = Math.max.apply(null, arr), // get the max of the array
                    maxi = arr.indexOf(max);
                arr[maxi] = -Infinity; // replace max in the array with -infinity
                var secondMax = Math.max.apply(null, arr); // get the new max
                arr[maxi] = max;
                return [secondMax, max];
            };

            let num_int_post_in_array = new_internalPostOffsetsValues.length - 2;

            if (this_numInternalPostsValue > num_int_post_in_array) {
                // must add posts
                let num_new_posts = this_numInternalPostsValue - num_int_post_in_array;
                let maxes = secondMax(new_internalPostOffsetsValues);

                let spacing = (maxes[1] - last_post_adj - maxes[0]) / (num_new_posts + 1);

                if (num_new_posts > 0)
                    for (var i = 0; i < num_new_posts; i++) {
                        let new_pos = maxes[0] + (i + 1) * spacing;
                        new_internalPostOffsetsValues.push(Math.round(new_pos));
                    }
            } else if (this_numInternalPostsValue < num_int_post_in_array) {
                // must remove posts
                let num_posts_to_remove = num_int_post_in_array - this_numInternalPostsValue;
                console.log("num_posts_to_remove", num_posts_to_remove);
                if (num_posts_to_remove > 0)
                    for (var i = 0; i < num_posts_to_remove; i++) {
                        let maxes = secondMax(new_internalPostOffsetsValues);
                        var index = new_internalPostOffsetsValues.indexOf(maxes[0]);
                        console.log(maxes, index);
                        if (index > -1) new_internalPostOffsetsValues.splice(index, 1);
                        console.log(new_internalPostOffsetsValues);
                    }
            }
        }
        return new_internalPostOffsetsValues.sort(function (a, b) {
            return a - b;
        });
    };

    const [numInternalPostsValue, setNumInternalPostsValue] = React.useState(
        data_mods && data_mods.NumInternalPosts
            ? data_mods.NumInternalPosts < min_int_cols
                ? min_int_cols
                : data_mods.NumInternalPosts
            : min_int_cols
    );
    const handleNumInternalPostsValue = (event, newValue) => {
        let newNumInternalPostsValue = newValue !== undefined && newValue != null ? newValue : event.target.value;
        if (newValue?.props?.value !== undefined) newNumInternalPostsValue = newValue.props.value;
        let oh_1_value = overhang1Value;
        if (END_1 === END_TYPES.BK2) {
            setOverhang1Value(0);
            oh_1_value = 0;
        } else if (END_1 === END_TYPES.POST && overhang1Value === 0) {
            setOverhang1Value(posttype.depth / 2);
            oh_1_value = posttype.depth / 2;
        }
        let oh_2_value = overhang2Value;
        if (END_2 === END_TYPES.BK2) {
            setOverhang2Value(0);
            oh_2_value = 0;
        } else if (END_2 === END_TYPES.POST && overhang2Value === 0) {
            setOverhang2Value(posttype.depth / 2);
            oh_2_value = posttype.depth / 2;
        }
        console.log(
            "handleNumInternalPostsValue",
            event,
            newValue,
            newNumInternalPostsValue,
            overhang1Value,
            END_1,
            oh_1_value,
            oh_2_value
        );

        let new_internalPostOffsetsValues = getPostsLocations(newNumInternalPostsValue, oh_1_value, oh_2_value);
        console.log("new_internalPostOffsetsValues", new_internalPostOffsetsValues);
        if (setInternalPostOffsetsValues) setInternalPostOffsetsValues(new_internalPostOffsetsValues);

        // setNumInternalPostsValue(newValue !== undefined ? newValue : event.target.value);
        setNumInternalPostsValue(newNumInternalPostsValue);
    };
    const [internalPostOffsetsValues, setInternalPostOffsetsValues] = React.useState(
        data_mods && data_mods.InternalPostOffsets
            ? [
                  default_OH1_value ?? data_mods.Overhang1,
                  ...data_mods.InternalPostOffsets,
                  beam_length - (default_OH2_value ?? data_mods.Overhang2),
              ]
            : getPostsLocations(numInternalPostsValue)
    );
    const handleInternalPostOffsetsValuesValue = (event, newValue) => {
        let values = newValue !== undefined ? newValue : event.target.value;

        var min = Math.min.apply(null, values), // get the max of the array
            mini = values.indexOf(min);

        var left_overhang = min;
        if (left_overhang > max_overhang) left_overhang = max_overhang;
        if (left_overhang < 1) left_overhang = first_post_adj;
        if (END_1 === END_TYPES.BK2) left_overhang = 0;
        // if (left_overhang <= first_post_adj) left_overhang = 0;
        setOverhang1Value(left_overhang);

        var max = Math.max.apply(null, values), // get the max of the array
            maxi = values.indexOf(max);

        var right_overhang = beam_length - max;
        if (right_overhang > max_overhang) right_overhang = max_overhang;
        if (right_overhang < 1) right_overhang = last_post_adj;
        if (END_2 === END_TYPES.BK2) right_overhang = 0;
        // if (right_overhang <= last_post_adj) right_overhang = 0;
        setOverhang2Value(right_overhang);

        values[maxi] = beam_length - right_overhang; // replace max in the array with beam_length

        values[mini] = left_overhang; // replace min in the array with 0

        //

        if (evenlySpacePosts) setReset(true);
        else setInternalPostOffsetsValues(values);
    };

    const handleClose = () => {
        onClose();
    };

    const [reset, setReset] = React.useState(false);
    React.useEffect(() => {
        if (reset) {
            handleEvenlySpacePosts(null, true, numInternalPostsValue);
            setReset(false);
        }
    }, [reset]);

    const handleReset = () => {
        setOverhang1Value(0);
        setOverhang2Value(0);
        setEvenlySpacePosts(true);
        setNumInternalPostsValue(min_int_cols);
        setStartPostSetting(-1);
        setEndPostSetting(-1);
        setReset(true);
        // setInternalPostOffsetsValues([0, beam_length]);
    };

    const handleDraw = () => {
        let draw_job = deepCopy(job);
        let new_data_mods = saveBeamModifications(false);

        let current_array = [];
        if (draw_job?.AreaSpecifications?.[areaIndex]?.["BEAMMODIFICATIONS"]) {
            current_array = draw_job?.AreaSpecifications?.[areaIndex]?.["BEAMMODIFICATIONS"];
        }
        current_array = current_array.filter((mod) => {
            return mod.Area === undefined || mod.Area === areaIndex;
        });
        console.log("current_array before", [...current_array]);

        // console.log("current_data_array", areaIndex, { ...new_data_array });
        // console.log("Ref", ref, "Ref2", ref2);
        let thisModification = getItemFromArray(current_array, "Ref", ref, "Ref2", ref2, 30, 90, true);
        if (thisModification) {
            current_array.forEach((mod, index) => {
                if (mod.Ref === thisModification.Ref && mod.Ref2 === thisModification.Ref2) {
                    current_array[index] = new_data_mods;
                }
            });
        } else {
            current_array.push(new_data_mods);
        }
        console.log("current_array after", [...current_array]);
        draw_job.AreaSpecifications[areaIndex]["BEAMMODIFICATIONS"] = current_array;
        if (THREED_mode) dispatch(updateLayout3D(false, draw_job));
        if (!THREED_mode || (THREED_mode && threed_mini_mode))
            dispatch(updateLayout2D(null, null, null, false, draw_job));
    };

    const saveBeamModifications = (save = true) => {
        let new_data_mods = data_mods ? { ...data_mods } : {};
        new_data_mods.P1 = ref4.split(";")[0].replaceAll("/", ",");
        new_data_mods.P2 = ref4.split(";")[1].replaceAll("/", ",");
        new_data_mods.Ref = ref4;
        new_data_mods.Ref2 = ref2;
        new_data_mods.Ref4 = ref4;
        new_data_mods.Area = item.areaIndex;
        new_data_mods.Overhang1 = overhang1Value ? overhang1Value : 0;
        if (new_data_mods.Overhang1 === first_post_adj) new_data_mods.Overhang1 = 0;
        else new_data_mods.Overhang1 -= first_post_adj;
        new_data_mods.Overhang2 = overhang2Value ? overhang2Value : 0;
        if (new_data_mods.Overhang2 === last_post_adj) new_data_mods.Overhang2 = 0;
        else new_data_mods.Overhang2 -= last_post_adj;
        new_data_mods.NumInternalPosts = numInternalPostsValue ? numInternalPostsValue : 0;
        new_data_mods.EvenlySpacePosts = evenlySpacePosts;
        new_data_mods.SetPost1 = startPostSetting;
        new_data_mods.SetPost2 = endPostSetting;

        let new_internalPostOffsetsValues = [...internalPostOffsetsValues];
        let ind_first = new_internalPostOffsetsValues.indexOf(overhang1Value);
        if (ind_first > -1) new_internalPostOffsetsValues.splice(ind_first, 1);
        let ind_last = new_internalPostOffsetsValues.indexOf(beam_length - overhang2Value);
        console.log(
            "new_internalPostOffsetsValues",
            new_internalPostOffsetsValues,
            ind_last,
            beam_length - overhang2Value
        );
        if (ind_last > -1) new_internalPostOffsetsValues.splice(ind_last, 1);

        // new_internalPostOffsetsValues.splice(new_internalPostOffsetsValues.indexOf(overhang1Value), 1);
        // new_internalPostOffsetsValues.splice(new_internalPostOffsetsValues.indexOf((beam_length - overhang2Value)), 1);
        console.log("spliced ar", new_internalPostOffsetsValues);

        new_data_mods.InternalPostOffsets =
            internalPostOffsetsValues && !evenlySpacePosts ? new_internalPostOffsetsValues : "";
        console.log("new_data_mods", new_data_mods);

        if (save) {
            if (
                new_data_mods.Overhang1 ||
                new_data_mods.Overhang2 ||
                new_data_mods.NumInternalPosts ||
                new_data_mods.SetPost1 !== data_mods?.SetPost1 ||
                new_data_mods.SetPost2 !== data_mods?.SetPost2
            ) {
                console.log("updating beam post mod", ref, new_data_mods);
                dispatch(
                    updateAreaSpecificationModificationArray(
                        item.areaIndex,
                        "BEAMMODIFICATIONS",
                        ref4,
                        null,
                        new_data_mods,
                        true,
                        ref2
                    )
                );
            } else {
                //delete paat from list
                console.log("deleting beam mod", ref);
                dispatch(deleteBeamPostMod(item.areaIndex, ref, ref2, ref4));
            }
            onClose();
        } else {
            return new_data_mods;
        }
    };

    // MODS

    console.log(beamType);
    const beam_spec = design_options[beamType.replace("beam", "beam_")];
    let beam_menu_items = [];
    if (beam_spec && beam_spec?.options)
        for (let key in beam_spec.options) {
            beam_menu_items.push(<ListSubheader key={key}>{key}</ListSubheader>);
            if (beam_spec.options[key])
                for (let key2 of beam_spec.options[key]) {
                    const beam = beam_types?.[key2];
                    if (beam) {
                        let id = beam.id ? beam.id : key2;
                        let name = beam.name ? beam.name : key2;
                        if (beam)
                            beam_menu_items.push(
                                <MenuItem key={id} value={key2}>
                                    {beam.thumbnail && (
                                        <div key={id} className={classes.roofsheet_chip}>
                                            <img alt="sheet thumb" src={beam.thumbnail} style={{ height: "32px" }} />
                                        </div>
                                    )}
                                    {name}
                                </MenuItem>
                            );
                    }
                }
        }

    if (!initialised) setInitialised(true);

    function AirbnbThumbComponent(props) {
        const classes = useStyles();
        const [thisValue, setThisValue] = React.useState(props["aria-valuenow"]);
        // const [thisValue, setThisValue] = React.useState(props["aria-valuenow"]);

        let min = props["aria-valuemin"];
        let max = props["aria-valuemax"];
        let range = max - min;
        let now_value = props["aria-valuenow"];
        const data_index = props["data-index"];
        const is_first = data_index === 0;
        const is_last = data_index === internalPostOffsetsValues.length - 1;

        let display_value = thisValue;
        if (display_value === null && now_value) display_value = now_value;

        let full_gap = 0;
        let gap = 0;
        let offset = 0;

        let gap2 = 0;
        let offset2 = 0;

        if (is_first) {
            // full_gap = overhang1Value > 100 ? overhang1Value : 0 + first_post_adj;
            // full_gap = overhang1Value > 50 ? overhang1Value : 0;
            full_gap = toNumber(now_value);
            // full_gap = overhang1Value ? overhang1Value : 0 + first_post_adj;
            if (is_last) full_gap += -last_post_adj;
            gap = full_gap - first_post_adj;
            // console.log("full_gap first", gap, overhang1Value, first_post_adj, range);
            let proportion = gap / range;
            offset = -(560 * (proportion / 2)) * 2;
        } else if (is_last) {
            full_gap = toNumber(now_value) - internalPostOffsetsValues[data_index - 1];
            gap = full_gap - posttype.depth;
            if (END_2 === END_TYPES.BK2) gap += posttype.depth / 2;
            // if (internalPostOffsetsValues.length === 2) gap -= first_post_adj;
            // else if (internalPostOffsetsValues.length > 2) gap -= posttype.depth / 2;
            let proportion = gap / range;
            offset = -(560 * (proportion / 2)) * 2;

            gap2 = overhang2Value ? overhang2Value - last_post_adj : 0;
            proportion = gap2 / range;
            offset2 = 560 * (proportion / 2) * 2;
        } else {
            full_gap = toNumber(now_value) - internalPostOffsetsValues[data_index - 1];
            gap = full_gap - posttype.depth;
            if (internalPostOffsetsValues.length > 2) {
                if (data_index === 1 && END_1 === END_TYPES.BK2) gap += posttype.depth / 2;
                // else gap -= posttype.depth;
            }
            let proportion = gap / range;
            offset = -(560 * (proportion / 2)) * 2;
        }
        let num_extra_post = 0;
        let num_extra_post_spacing = 0;
        let extra_posts = [];

        let extra_post_max_spacing = SplicingLength;
        let splice_text = "[splice]";
        if (MaxPostSpacing < SplicingLength && numInternalPostsValue === 0 && beamType === "beam1") {
            extra_post_max_spacing = MaxPostSpacing;
            splice_text = " [auto] ";
        }

        if (full_gap > extra_post_max_spacing && beamType === "beam1") {
            num_extra_post = Math.trunc(full_gap / extra_post_max_spacing);
            num_extra_post_spacing = full_gap / (num_extra_post + 1);
            let num_extra_post_spacing_porportion = (num_extra_post_spacing / range) * 560;

            for (let i = 1; i < num_extra_post + 1; i++) {
                let this_post_spacing = -num_extra_post_spacing_porportion * i;
                extra_posts.push(
                    <div
                        key={data_index + i.toString()}
                        className={classes.ghostPostContainer}
                        style={{ marginLeft: this_post_spacing * 2 + 10 + "px" }}
                    >
                        <span className={classes.ghostPost}></span>
                        <span className={classes.ghostPostText}>{splice_text}</span>
                        {splice_text === "[splice]" && <div className={classes.ghostSplice}></div>}
                    </div>
                );
            }
        }
        // console.log(
        //     "full_gap",
        //     data_index,
        //     full_gap,
        //     SplicingLength,
        //     area_BEAMS_AND_POSTS.PostSpacing,
        //     Number(area_BEAMS_AND_POSTS.PostSpacing) < SplicingLength,
        //     extra_post_max_spacing,
        //     beamType
        // );

        const [gapValue, setGapValue] = React.useState(gap);
        let gap_display_value = gapValue;
        if (gap_display_value === null && gap) gap_display_value = gap;

        const [gap2Value, setGap2Value] = React.useState(gap2);
        let gap2_display_value = gap2Value;
        if (gap2_display_value === null && gap2) gap2_display_value = gap2;

        // if (data_index === 1) gap_display_value-=first_post_adj;
        // else if (data_index === internalPostOffsetsValues.length-1) gap_display_value-=last_post_adj;

        // console.log("handle" + data_index, offset, sliderRef);

        let handlebar_offset = 0;
        if (is_last) handlebar_offset = 9;
        // if ((data_index === 0)) handlebar_offset = -8;

        let post_adjustment = 7;
        // if (is_last && END_2 === "BK2") post_adjustment = 0;

        offset += handlebar_offset;
        // if (is_first) offset -= 40;

        let disabled_style = {
            background: "grey",
            borderColor: "grey",
            color: "grey",
        };

        let disabled = evenlySpacePosts && !is_first && !is_last;

        if (is_first && END_1 === END_TYPES.BK2) {
            return (
                <span
                    {...props}
                    className={props.className + " " + classes.end}
                    style={{
                        ...props.style,
                        width: "4px !important",
                        border: "none !important",
                        marginLeft: "2px !important",
                    }}
                >
                    <div
                        className={classes.handleContainer}
                        style={data_index === internalPostOffsetsValues.length - 1 ? { marginLeft: "-29px" } : {}}
                    >
                        {/* <span className={classes.handleBar + " " + classes.handleBarTop} style={{ marginLeft: handlebar_offset + "px", ...(disabled) ? {color: "grey"} : {} }}>|</span> */}
                    </div>
                </span>
            );
        } else if (is_last && END_2 === END_TYPES.BK2) {
            return (
                <span
                    {...props}
                    className={props.className + " " + classes.end}
                    style={{
                        ...props.style,
                        width: "4px !important",
                        border: "none !important",
                        marginLeft: "2px !important",
                    }}
                >
                    <div
                        className={classes.handleContainer}
                        style={data_index === internalPostOffsetsValues.length - 1 ? { marginLeft: "-29px" } : {}}
                    >
                        {/* <span className={classes.handleBar + " " + classes.handleBarTop} style={{ marginLeft: handlebar_offset + "px", ...(disabled) ? {color: "grey"} : {} }}>|</span> */}
                    </div>

                    {extra_posts}
                    {gap > 0 && (
                        <div
                            className={classes.handleContainer}
                            style={{ marginLeft: offset - 45 + "px", marginTop: "50px" }}
                        >
                            <input
                                type="text"
                                id="standard-basic"
                                label=""
                                disabled={evenlySpacePosts && !is_first && !is_last}
                                value={Math.round(gap_display_value)}
                                className={classes.handleText}
                                onMouseDown={(e) => e.stopPropagation()}
                                onChange={(e) => setGapValue(toNumber(e.target.value.replace("mm", "")))}
                                onBlur={(e) => {
                                    let new_value = [...internalPostOffsetsValues];
                                    let gap_diff = gap_display_value - gap;
                                    if (data_index === internalPostOffsetsValues.length - 1)
                                        new_value[data_index - 1] = toNumber(new_value[data_index - 1]) - gap_diff;
                                    else new_value[data_index] = toNumber(display_value) + gap_diff;
                                    console.log(new_value);
                                    handleInternalPostOffsetsValuesValue(e, new_value);
                                    // if (evenlySpacePosts) handleEvenlySpacePosts(null, true, numInternalPostsValue);
                                }}
                                onFocus={(event) => {
                                    event.target.select();
                                }}
                                onKeyPress={(e) => {
                                    if (e.key == "Enter") {
                                        e.target.blur();
                                    }
                                }}
                            />
                            <span className={classes.handleEndAdornment}>mm</span>
                        </div>
                    )}
                </span>
            );
        }
        return (
            <span {...props} style={{ ...props.style, ...(disabled ? disabled_style : {}) }}>
                <div
                    className={classes.handleContainer}
                    style={data_index === internalPostOffsetsValues.length - 1 ? { marginLeft: "-30px" } : {}}
                >
                    <input
                        type="text"
                        id="standard-basic"
                        label=""
                        disabled={evenlySpacePosts && !is_first && !is_last}
                        value={display_value}
                        className={classes.handleText}
                        onMouseDown={(e) => e.stopPropagation()}
                        onChange={(e) => setThisValue(e.target.value)}
                        onBlur={(e) => {
                            let new_value = [...internalPostOffsetsValues];
                            new_value[data_index] = toNumber(display_value);
                            console.log(new_value);
                            handleInternalPostOffsetsValuesValue(e, new_value);
                            // if (evenlySpacePosts) handleEvenlySpacePosts(null, true, numInternalPostsValue);
                        }}
                        onFocus={(event) => {
                            event.target.select();
                        }}
                        onKeyPress={(e) => {
                            if (e.key == "Enter") {
                                e.target.blur();
                            }
                        }}
                    />
                    <span className={classes.handleEndAdornment}>mm</span>
                    <span
                        className={classes.handleBar}
                        style={{ marginLeft: handlebar_offset - post_adjustment + "px" }}
                    >
                        |
                    </span>
                    <span
                        className={classes.handleBar + " " + classes.handleBarTop}
                        style={{ marginLeft: handlebar_offset + "px", ...(disabled ? { color: "grey" } : {}) }}
                    >
                        |
                    </span>
                    <span
                        className={classes.handleBar}
                        style={{ marginLeft: handlebar_offset + post_adjustment + "px" }}
                    >
                        |
                    </span>
                </div>
                {extra_posts}
                {gap !== 0 && (
                    <div
                        className={classes.handleContainer}
                        style={{ marginLeft: offset - 45 + "px", marginTop: "50px" }}
                    >
                        <input
                            type="text"
                            id="standard-basic"
                            label=""
                            disabled={evenlySpacePosts && !is_first && !is_last}
                            value={Math.round(gap_display_value)}
                            className={classes.handleText}
                            onMouseDown={(e) => e.stopPropagation()}
                            onChange={(e) => setGapValue(toNumber(e.target.value.replace("mm", "")))}
                            onBlur={(e) => {
                                let new_value = [...internalPostOffsetsValues];
                                let gap_diff = gap_display_value - gap;
                                if (data_index === internalPostOffsetsValues.length - 1)
                                    new_value[data_index - 1] = toNumber(new_value[data_index - 1]) - gap_diff;
                                else new_value[data_index] = toNumber(display_value) + gap_diff;
                                console.log(new_value);
                                handleInternalPostOffsetsValuesValue(e, new_value);
                                // if (evenlySpacePosts) handleEvenlySpacePosts(null, true, numInternalPostsValue);
                            }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onKeyPress={(e) => {
                                if (e.key == "Enter") {
                                    e.target.blur();
                                }
                            }}
                        />
                        <span className={classes.handleEndAdornment}>mm</span>
                    </div>
                )}
                {gap2 !== 0 && (
                    <div className={classes.handleContainer} style={{ marginLeft: offset2 + "px", marginTop: "50px" }}>
                        <input
                            type="text"
                            id="standard-basic"
                            label=""
                            disabled={evenlySpacePosts && !is_first && !is_last}
                            value={Math.round(gap2_display_value)}
                            className={classes.handleText}
                            onMouseDown={(e) => e.stopPropagation()}
                            onChange={(e) => setGap2Value(toNumber(e.target.value.replace("mm", "")))}
                            onBlur={(e) => {
                                let new_value = [...internalPostOffsetsValues];
                                let gap_diff = gap2_display_value - gap2;
                                new_value[data_index] = toNumber(new_value[data_index]) - gap_diff;
                                console.log(new_value);
                                handleInternalPostOffsetsValuesValue(e, new_value);
                                // if (evenlySpacePosts) handleEvenlySpacePosts(null, true, numInternalPostsValue);
                            }}
                            onFocus={(event) => {
                                event.target.select();
                            }}
                            onKeyPress={(e) => {
                                if (e.key == "Enter") {
                                    e.target.blur();
                                }
                            }}
                        />
                        <span className={classes.handleEndAdornment}>mm</span>
                    </div>
                )}
            </span>
        );
    }

    let post_spacing_note = [];
    if (MaxPostSpacing < beam_length && MaxPostSpacing < SplicingLength && beamType === "beam1") {
        let num_posts = Math.trunc(beam_length / MaxPostSpacing);
        post_spacing_note.push(
            <>
                This area has an imported <strong>Max Post Spacing</strong> set to {MaxPostSpacing} mm (
                <Link
                    style={{ color: "blue", cursor: "pointer" }}
                    onClick={(e) => {
                        e.preventDefault();
                        dispatch(updateAreaSpecificationBeamPost(item.areaIndex, null, "PostSpacing", 20000));
                    }}
                >
                    remove
                </Link>
                ). If internal posts is 0, {num_posts} supports will be automatically added.
            </>
        );
    }
    if (SplicingLength < beam_length) {
        if (post_spacing_note.length > 0) post_spacing_note.push(<br />);
        post_spacing_note.push(
            <>
                <strong>Beam Splice Length</strong> set to {SplicingLength}mm. If any beam section is over this length,
                the beam will be spliced and a support will be automatically added under the splice.
            </>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: "move" }}>Modify Beam Post Options</DialogTitle>
            {window.debug && (
                <Typography id="range-slider" variant="caption" gutterBottom>
                    {"ref " + ref4 + " / ref2 " + ref2}
                    <br />
                    {"length:" + beam_length}
                    <br />
                    {"length_actual:" + beam_length_actual}
                    <br />
                    {"length_xy:" + beam_length_xy}
                    <br />
                    {"length_ref:" + beam_length_xy_Ref_actual + " xy:" + beam_length_xy_Ref}
                    <br />
                    {"end1:" + END_1 + " end2:" + END_2}
                </Typography>
            )}
            <DialogContent style={{ overflow: "hidden", display: "flex", flexDirection: "column", width: "600px" }}>
                {!item && <DialogContentText>Beam data is not defined</DialogContentText>}
                {item && (
                    <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
                        {post_spacing_note.length > 0 && <DialogContentText>{post_spacing_note}</DialogContentText>}
                        <BSL_Common.SectionRow>
                            <BSL_Select
                                style={{ flex: 1 }}
                                value={numInternalPostsValue}
                                tight={true}
                                items={CreateIntegerRange(min_int_cols ? min_int_cols : 0, 12, 1)}
                                label={"Internal Posts"}
                                onChange={handleNumInternalPostsValue}
                            />
                            <BSL_CheckBox
                                tight
                                checked={evenlySpacePosts}
                                returnInt
                                main_label={<>&nbsp;</>}
                                label="Evenly Space Internal Posts"
                                onChange={(val) => handleEvenlySpacePosts(null, val)}
                                style={{
                                    flex: 3,
                                }}
                            />
                        </BSL_Common.SectionRow>
                        <BSL_Common.SectionRow>
                            <SegmentedButtonGroup
                                label="Start Post"
                                value={startPostSetting}
                                tight
                                items={[
                                    {
                                        Key: -1,
                                        Display: "Auto",
                                    },
                                    {
                                        Key: 0,
                                        Display: "Off",
                                    },
                                    {
                                        Key: 1,
                                        Display: "On",
                                    },
                                ]}
                                onChange={(e, val) => {
                                    setStartPostSetting(val);
                                }}
                            />
                            <SegmentedButtonGroup
                                label="End Post"
                                value={endPostSetting}
                                tight
                                items={[
                                    {
                                        Key: -1,
                                        Display: "Auto",
                                    },
                                    {
                                        Key: 0,
                                        Display: "Off",
                                    },
                                    {
                                        Key: 1,
                                        Display: "On",
                                    },
                                ]}
                                onChange={(e, val) => {
                                    setEndPostSetting(val);
                                }}
                                style={{
                                    textAlignLast: "end",
                                    textAlign: "-webkit-right",
                                }}
                            />
                        </BSL_Common.SectionRow>
                        {/* 
            <Typography id="range-slider" gutterBottom>
              Internal Posts
            </Typography>
            <AreaSelectField
              dark
              value={numInternalPostsValue}
              items={CreateIntegerRange(min_int_cols ? min_int_cols : 0, 12, 1)}
              clip_overflow
              onChange={handleNumInternalPostsValue}
            />

              <FormControlLabel
            control={
              <Checkbox
                checked={evenlySpacePosts}
                onChange={handleEvenlySpacePosts}
                name="checkedB"
                color="primary"
              />
            }
            label="Evenly Space Internal Posts"
              /> */}

                        <AttachmentSlider
                            // key={
                            //     numInternalPostsValue +
                            //     evenlySpacePosts +
                            //     JSON.stringify(internalPostOffsetsValues) +
                            //     startPostSetting +
                            //     endPostSetting
                            // } // key means sliders don't move smoothly
                            ref={sliderRef}
                            // disabled={evenlySpacePosts}
                            ThumbComponent={AirbnbThumbComponent}
                            value={internalPostOffsetsValues}
                            onChange={handleInternalPostOffsetsValuesValue}
                            valueLabelDisplay="auto"
                            aria-labelledby="range-slider"
                            // valueLabelDisplay="on"
                            // min={first_post_adj}
                            // max={beam_length - last_post_adj}
                            min={0}
                            max={beam_length}
                            classes={{
                                disabled: classes.sliderDisabled,
                            }}
                        />
                        <div
                            style={{
                                borderRadius: "50%",
                                width: "50px",
                                height: "50px",
                                marginTop: "-40px",
                                marginLeft: "-20px",
                                border: "3px dotted darkgreen",
                                // display: inline-block;
                                // position: absolute;
                            }}
                        ></div>
                        <div
                            style={{
                                borderRadius: "50%",
                                width: "50px",
                                height: "50px",
                                marginTop: "-48px",
                                marginRight: "-20px",
                                border: "3px dotted darkred",
                                alignSelf: "end",
                                // display: inline-block;
                                // position: absolute;
                            }}
                        ></div>
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleReset}
                    color="primary"
                    style={{
                        position: "absolute",
                        left: "20px",
                    }}
                >
                    Reset
                </Button>
                <Button
                    autoFocus
                    onClick={handleDraw}
                    color="primary"
                    style={{
                        position: "absolute",
                        left: "80px",
                    }}
                >
                    Redraw
                </Button>
                <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={saveBeamModifications} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
